import type { StoreFrontDto } from '@b-stock/listing-api-client'

import { ColumnLayoutIdEnum } from '../types'

const MOBILE_COLUMN_LAYOUT_IDS: readonly string[] = [
  ColumnLayoutIdEnum.STOREFRONT_MOBILE,
  ColumnLayoutIdEnum.STOREFRONT_MOBILE_ATT,
  ColumnLayoutIdEnum.STOREFRONT_MOBILE_T_MOBILE,
]

/**
 * Whether a storefront is a mobile-category storefront (AT&T, other carrier
 * liquidations), read directly off its configured column layout — the same
 * signal that already drives the "mobile" ListViewSurface
 * template (see listViewSurface.ts). Read here directly rather than through
 * that surface helper, since a mobile storefront with a custom column layout
 * override would otherwise report `template: 'custom'` and lose this
 * classification — storefront category and column customization are
 * independent concerns.
 */
export const isMobileCategoryStorefront = (
  storefront: StoreFrontDto | undefined
): boolean =>
  MOBILE_COLUMN_LAYOUT_IDS.includes(storefront?.options?.columnLayoutId ?? '')
